//import CompStuPrescribeDataFunc from "@/pcomponents/common/content/edu/comp_stu_prescribe/func/data_func";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';

class CompStuPrescribeDataFunc {
  static default_info = {
    a_ymd: "",
    a_seq: "",
    a_mcomp_seq: "",
    a_stu_seq: "",
    a_mcomp_name: "",
    a_stu_name: "",
    a_date: "",
    a_stu_grade_str: "",
    a_write_mcomp_seq: "",
    a_write_mcomp_user_seq: "",
    a_write_mcomp_name: "",
    a_writer: "",
    a_prescribe_mcomp_seq: "",
    a_prescribe_mcomp_user_seq: "",
    a_prescribe_mcomp_name: "",
    a_prescriber: "",
    a_title: "",
    a_subject: "",
    a_state: "",
    a_is_request: "",
    a_request_date: "",
    a_is_success: "",
    a_success_date: "",
    a_is_success_check: "",
    a_success_check_date: "",
    a_check_content: "",
    a_att_obs_result: "",
    a_att_obs_result_memo: "",
    a_att_interpret: "",
    a_att_interpret_memo: "",
    a_att_learning_mean: "",
    a_att_learning_mean_memo: "",
    a_att_teaching_point: "",
    a_att_teaching_point_memo: "",
    a_type_analysis: "",
    a_type_analysis_memo: "",
    a_type_strength: "",
    a_type_strength_memo: "",
    a_type_caution: "",
    a_type_caution_memo: "",
    a_type_growth_direction: "",
    a_type_growth_direction_memo: "",
    a_res_score_range: "",
    a_res_score_range_memo: "",
    a_res_unit_analysis: "",
    a_res_unit_analysis_memo: "",
    a_res_final_analysis: "",
    a_res_final_analysis_memo: "",
    a_res_guide_direction: "",
    a_res_guide_direction_memo: "",
    a_do_evaluation: "",
    a_do_evaluation_memo: "",
    a_do_level: "",
    a_do_level_memo: "",
    a_pres_overall_comment: "",
    a_pres_overall_comment_memo: "",
    a_pres_weekly_plan: "",
    a_pres_weekly_plan_memo: "",
  };
  static select_state_arr = [
    { value: "ready", text: "준비" },
    { value: "ing", text: "처방중" },
    { value: "complete", text: "완료" },
  ];
}
export default CompStuPrescribeDataFunc;